import "../assets/scss/components/_hilton-header.scss";
import Hilton from "../assets/images/hilton-doubletree.svg?react";
import Config from "../Config";

export const HiltonHeader = () => {
	const { Logo } = Config;
	return (
		<div className="hilton-header">
			<div className="container">
				<div className="row align-items-center justify-content-space-between">
					<div className="col-1">
						{/* <img
							src={hilton}
							alt="Hilton Doubletree Logo"
							className="logo-hilton"
						/> */}
						<Hilton className="logo-hilton" alt="Hilton Doubletree Logo" />
					</div>
					<div className="col-1">
						<Logo className="logo-123" alt="123 Flowers Logo" />
					</div>
				</div>
			</div>
		</div>
	);
};
